/*  ========================================================================
    # Components - Contributor Card
    ========================================================================  */

import React from 'react';
import PropTypes from 'prop-types';
import useResizeObserver from 'use-resize-observer';
import LazyImage from './LazyImage';

const ContributorCard = ({ name, surname, image, position, excerpt, classes, permalink }) => {
  const { ref, height = 1 } = useResizeObserver();

  return (
    <a href={permalink} className={`c-contributor-card ` + classes} aria-label={name + ' ' + surname}>
      <LazyImage
        defaultUrl={image.sizes['medium_large']}
        placeholderUrl={image.sizes.placeholder}
        figureClass='c-contributor-card__image'
      ></LazyImage>
      <div className='c-contributor-card__gradient'></div>
      <div
        className={`c-contributor-card__content ${excerpt ? 'c-contributor-card__content-with-excerpt' : ''
          }`}
        style={{ '--excerpt-height': `${height}px` }}
      >
        <h3 className='c-contributor-card__name' dangerouslySetInnerHTML={{ __html: name + ' ' + surname }}></h3>
        <h5 className='c-contributor-card__position'>{position}</h5>
        {excerpt && (
          <p className='c-contributor-card__excerpt' ref={ref}>
            {excerpt}
          </p>
        )}
      </div>
    </a>
  );
};

ContributorCard.propTypes = {
  name: PropTypes.string,
  surname: PropTypes.string,
  image: PropTypes.object,
  position: PropTypes.string,
  excerpt: PropTypes.string,
  classes: PropTypes.string,
  permalink: PropTypes.string
};

export default ContributorCard;
